import React from 'react';

type ButtonTone = 'default' | 'on-dark';

type ButtonOwnProps<C extends React.ElementType> = {
  as?: C;
  tone?: ButtonTone;
  className?: string;
  children?: React.ReactNode;
};

type GhostButtonProps<C extends React.ElementType> = ButtonOwnProps<C> &
  Omit<React.ComponentPropsWithoutRef<C>, keyof ButtonOwnProps<C>>;

const TONE_CLASS: Record<ButtonTone, string> = {
  default: 'border-[1.5px] border-we-ink/55 text-we-ink',
  'on-dark': 'border-[1.5px] border-we-bg/55 text-we-bg',
};

const LAYOUT = 'rounded-full px-7 py-3.5 font-bold';

function GhostButton<C extends React.ElementType = 'button'>({
  as,
  tone = 'default',
  className = '',
  children,
  ...rest
}: GhostButtonProps<C>) {
  const Component = as ?? 'button';
  return (
    <Component className={`${TONE_CLASS[tone]} ${LAYOUT} ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
}

export default GhostButton;
